<div class="row">
  <div class="col-12 col-md-6 d-flex align-items-center justify-content-center justify-content-md-end">
    <h2 translate>SCHEDULERS</h2>
  </div>
  <div class="col-12 col-md-6">
    <div class="d-block">
      <span translate>UPDATE_EVERY</span> <b> {{ intervaleSeconds }} </b> <span translate>SECONDS</span>
    </div>
    <div class="d-block">
      <span translate>LAST_UPDATED</span>:
      <b>{{ lastUpdate | date: dateUtilService.dateFormat + '
                HH:mm:ss' }}</b>
    </div>
    <div class="d-block">
      <span class="btn btn-link p-0" (click)="clearAllError()" translate>CLEAR_ALL_ERROR_LOGS</span>
    </div>
  </div>
</div>
<div class="row mt-5">
  <div class="col-12 col-sm-6 col-md-4 border-bottom" *ngFor="let schedule of schedulersList">
    <div class="card mb-3 shadow-sm">
      <div class="card-header d-flex align-items-center gap-2">
        <div
          class="rounded-circle d-flex justify-content-center align-items-center border flex-shrink-0"
          style="width: 40px; height: 40px; border-width: 3px !important"
          [ngClass]="{
            'border-success': schedule.jobdatamap?.exceptionCounter == 0,
            'border-danger': !(schedule.jobdatamap?.exceptionCounter === 0),
            btn: schedule.jobdatamap?.lastExceptionDate
          }"
          (click)="showLastExceptionTrace(schedule, content)"
        >
          {{ schedule.jobdatamap?.exceptionCounter || 0 }}
        </div>
        <div class="flex-grow-1 overflow-hidden">
          <h5 class="text-break mb-0">{{ schedule.jobName }}</h5>
          <span *ngIf="schedule.executionGroup" class="badge badge-secondary">
            Group: {{ schedule.executionGroup }}
          </span>
          <small>
            <label translate>LAST_STATUS</label>: <b>{{ schedule.jobdatamap?.lastStatus }}</b>
            <button
              *ngIf="schedule.jobdatamap?.lastExceptionDate"
              type="button"
              class="btn btn-link btn-sm p-0 ms-1"
              (click)="showLastExceptionTrace(schedule, content)"
            >
              <i class="fas fa-question-circle"></i>
            </button>
          </small>
        </div>
      </div>
      <div class="card-body p-0">
        <div class="row border-bottom px-3 py-2">
          <div class="col-4">
            <label translate>CRON</label>
          </div>
          <div class="col-8 text-right text-break">
            <b>{{ schedule.cronExpression }}</b>
          </div>
        </div>
        <div class="border-bottom">
          <button
            type="button"
            class="btn btn-link text-decoration-none w-100 px-3 py-2 d-flex justify-content-between align-items-center text-body"
            (click)="panelOpenState(schedule.jobName, !panelOpenState(schedule.jobName))"
          >
            <label class="mb-0" translate>LAST_EXECUTION_TIME</label>
            <span class="text-muted">
              {{ schedule.jobdatamap?.lastExecutionTime / 1000 }} s
              <i class="fas ms-1" [ngClass]="panelOpenState(schedule.jobName) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </span>
          </button>
          <div [class.d-none]="!panelOpenState(schedule.jobName)" class="px-3 pb-2">
            <div class="row mt-2 border-bottom">
              <div class="col-4"><label translate>TRIGGERS</label></div>
              <div class="col-8 text-right text-break">{{ schedule.triggerCount }}</div>
            </div>
            <div class="row mt-2 border-bottom">
              <div class="col-4"><label translate>EXECUTIONS</label></div>
              <div class="col-8 text-right text-break">{{ schedule.jobdatamap?.executionCounter }}</div>
            </div>
            <div class="row mt-2 border-bottom">
              <div class="col-4"><label translate>FAILED</label></div>
              <div class="col-8 text-right text-break">{{ schedule.jobdatamap?.exceptionCounter }}</div>
            </div>
            <div class="row mt-2 border-bottom">
              <div class="col-4"><label translate>NEXT_EXECUTION_TIME</label></div>
              <div class="col-8 text-right text-break">
                {{ schedule.nextFireTime | date: dateUtilService.dateFormat + ' HH:mm:ss' }}
              </div>
            </div>
            <div class="row mt-2 border-bottom">
              <div class="col-4"><label translate>INTERNAL_STATE</label></div>
              <div class="col-8 text-right text-break">{{ schedule.jobdatamap?.statusDetails.statusString }}</div>
            </div>
            <div class="row mt-2 border-bottom" *ngIf="schedule.jobdatamap?.running && schedule.jobdatamap?.lastStartTime">
              <div class="col-4"><label translate>STARTED</label></div>
              <div class="col-8 text-right text-break">
                {{ schedule.jobdatamap?.lastStartTime | date: 'longTime' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button
          (click)="triggerJob(schedule)"
          type="button"
          class="btn btn-primary"
          [disabled]="schedule.jobdatamap?.running ? true : undefined"
        >
          <span translate>
            {{ schedule.jobdatamap?.running ? 'EXECUTING' : 'TRIGGER_NOW' }}
            <i *ngIf="schedule.jobdatamap?.running" class="fa fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <div>
      <h4 class="modal-title" id="modal-basic-title">{{ lastException?.jobName }} - Exception details</h4>
      <span>{{ lastException?.lastExceptionDate }}</span>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- <h4 class="text-center">{{lastException?.lastExceptionDate}}</h4> -->
    <pre>
        {{ lastException?.lastExceptionTrace }}
      </pre
    >
  </div>
  <div class="modal-footer">
    <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Save</button> -->
  </div>
</ng-template>
